import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Container,
  Table,
} from "reactstrap";
import { MdOutlineAdd } from "react-icons/md";
import Image from "next/image";

import classes from "@/styles/partners/partner.module.css";
import { logo, smallLogo } from "@/utils/images";
import fulfillmentPartners from "@/data/fulfillment-partner.json";
// import IntegrationDetails from "./integration-details";
import { useIsMobile } from "@/hooks/useIsMobile";
import { partner } from "@/utils/content";

const LinkYourUPSAccount = () => {
  const isMobile = useIsMobile();
  const content = partner.en;
  const [open, setOpen] = useState<string>("1");

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };
  const partnerDetails: any = fulfillmentPartners.find(
    (t) => t.url === `/ups-canada`
  );

  return (
    <>
      <div className={classes.hero}>
        <div>
          <Image
            className={`${isMobile ? "me-4" : "ms-5"} img-fluid`}
            src={isMobile ? smallLogo : logo}
            alt="ShipVista logo"
            height={80}
            width={isMobile ? 80 : 300}
          />
        </div>
        <div>
          <MdOutlineAdd className={`text-darkblue ${classes.plusIco}`} />
        </div>
        <div>
          <Image
            className={`img-fluid ${isMobile ? `${classes.heroImg}` : "me-5"}`}
            src={partnerDetails.logoPath}
            alt={partnerDetails.name}
            height={150}
            width={250}
          />
        </div>
      </div>

      <Container>
        {/* <IntegrationDetails partnerDetails={partnerDetails} /> */}
        <section className="mb-5 mt-5">
          {
            <Accordion
              className="my-4"
              open={open}
              //@ts-ignore
              toggle={toggle}
            >
              <AccordionItem>
                <AccordionHeader targetId="1">
                  {content.requirement}
                </AccordionHeader>
                <AccordionBody accordionId="1">
                  <p className="fw-bold">{content.integrationRequirements}</p>
                  <ul>
                    {partnerDetails?.integration &&
                      partnerDetails?.integration.requirements &&
                      partnerDetails?.integration.requirements.map(
                        (r: string, i: number) => <li key={r + i}>{r}</li>
                      )}
                  </ul>
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeader targetId="2">
                  {content.connect}
                </AccordionHeader>
                <AccordionBody accordionId="2">
                  <p>
                    {content.followSteps}&nbsp;{partnerDetails.name}
                    &nbsp;{content.toShipVista}
                  </p>
                  <ol className={classes.ol}>
                    {partnerDetails?.integration &&
                      partnerDetails?.integration.connect &&
                      partnerDetails?.integration.connect.map(
                        (i: any, index: any) => (
                          <li key={`${i.id}${index}`}>
                            <p>{i.list}</p>
                            {i.img && (
                              <Image
                                className={classes.listImg}
                                src={i.img}
                                alt={i.img}
                                height={300}
                                width={200}
                              />
                            )}
                          </li>
                        )
                      )}
                  </ol>
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeader targetId="3">
                  {content.availableFeatures}
                </AccordionHeader>
                <AccordionBody accordionId="3">
                  <p>
                    {content.shipvistaIntegration}&nbsp;
                    {partnerDetails.name}&nbsp;{content.supports}
                  </p>
                  {partnerDetails?.integration &&
                    partnerDetails?.integration.features && (
                      <>
                        <p className="fw-bold mb-1">
                          {content.commonIntegrationFeatures}
                        </p>
                        <Table striped bordered hover>
                          <thead className="bg-dark text-white">
                            <tr>
                              <th className="w-75">{content.feature}</th>
                              <th className="">{content.support}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partnerDetails?.integration.features &&
                              partnerDetails?.integration.features.map(
                                (f: any) => {
                                  return (
                                    <tr key={f.name}>
                                      <td>{f.name}</td>
                                      <td>{f.status}</td>
                                    </tr>
                                  );
                                }
                              )}
                          </tbody>
                        </Table>
                      </>
                    )}
                  {/* <p className="fw-bold mb-1">{content.shipvistaUpdate}</p> */}
                  {partnerDetails?.integration &&
                    partnerDetails?.integration.shipVistaStatus && (
                      <Table striped bordered hover>
                        <thead className="bg-dark text-white">
                          <tr>
                            <th className="w-75 fw-light">
                              {content.shipvista}&nbsp;{content.status}
                            </th>
                            <th className="fw-light">
                              {partnerDetails.name}&nbsp;
                              {content.status}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {partnerDetails?.integration.shipVistaStatus &&
                            partnerDetails?.integration.shipVistaStatus.map(
                              (f: any) => {
                                return (
                                  <tr key={f.name}>
                                    <td>{f.name}</td>
                                    <td>{f.status}</td>
                                  </tr>
                                );
                              }
                            )}
                        </tbody>
                      </Table>
                    )}
                  {partnerDetails?.integration &&
                    partnerDetails?.integration.shipvistaUpdate && (
                      <>
                        <p className="fw-bold mb-1">
                          {content.shipvistaUpdate}
                        </p>
                        <Table striped bordered hover>
                          <thead className="bg-dark text-white">
                            <tr>
                              <th className="w-75 fw-light">{content.field}</th>
                              <th className="fw-light">{content.support}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {partnerDetails?.integration.shipvistaUpdate &&
                              partnerDetails?.integration.shipvistaUpdate.map(
                                (f: any) => {
                                  return (
                                    <tr key={f.name}>
                                      <td>{f.name}</td>
                                      <td>{f.status}</td>
                                    </tr>
                                  );
                                }
                              )}
                          </tbody>
                        </Table>
                      </>
                    )}
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeader targetId="4">
                  {content.additionalDetails}
                </AccordionHeader>
                <AccordionBody accordionId="4">
                  <ul>
                    <li>
                      <p className="text-decoration-underline">
                        {partnerDetails?.integration &&
                        partnerDetails?.integration.additionalDetails
                          ? partnerDetails?.integration.additionalDetails
                          : "N/A"}
                      </p>
                    </li>
                  </ul>
                </AccordionBody>
              </AccordionItem>
              <AccordionItem>
                <AccordionHeader targetId="5">
                  {content.troubleshooting}
                </AccordionHeader>
                <AccordionBody accordionId="5">
                  <p>
                    {partnerDetails?.integration &&
                    partnerDetails?.integration.troubleshooting
                      ? partnerDetails?.integration.troubleshooting
                      : "N/A"}
                  </p>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          }
        </section>
      </Container>
    </>
  );
};

export default LinkYourUPSAccount;
